import { useRef } from "react";
import { Loader2, Upload, X, AlertCircle } from "lucide-react";

export const HealthDocsSection = ({ healthDocs, uploading, onUpload, onRemove }) => {
  const fileInputRef = useRef(null);

  return (
    <div className="glass-card p-6 space-y-6">
      <div className="flex items-start justify-between">
        <div>
          <h2 className="text-xl text-[#EDEDED] mb-1">Health Certifications *</h2>
          <p className="text-sm text-[#71717A]">
            Upload veterinary records, health tests, certifications (PDF, JPG, PNG)
          </p>
        </div>
        <span className="px-2 py-1 bg-[#D4AF37]/20 text-[#D4AF37] text-xs rounded-full">Required</span>
      </div>

      {healthDocs.length > 0 && (
        <div className="space-y-2">
          {healthDocs.map((doc, index) => (
            <div key={doc} className="flex items-center justify-between p-3 bg-[#18181B] rounded-lg">
              <span className="text-sm text-[#EDEDED] truncate">{doc.split("/").pop()}</span>
              <button
                type="button"
                onClick={() => onRemove(index)}
                className="p-1 hover:bg-[#27272A] rounded"
                data-testid={`remove-doc-${index}`}
              >
                <X className="w-4 h-4 text-[#71717A]" />
              </button>
            </div>
          ))}
        </div>
      )}

      <input
        ref={fileInputRef}
        type="file"
        accept=".pdf,.jpg,.jpeg,.png"
        multiple
        onChange={onUpload}
        className="hidden"
      />

      <button
        type="button"
        onClick={() => fileInputRef.current?.click()}
        disabled={uploading || healthDocs.length >= 5}
        className="w-full p-4 border-2 border-dashed border-[#3F3F46] rounded-xl hover:border-[#D4AF37] transition-colors flex items-center justify-center gap-2 text-[#A1A1AA] disabled:opacity-50"
        data-testid="upload-health-docs-btn"
      >
        {uploading ? (
          <Loader2 className="w-5 h-5 animate-spin" />
        ) : (
          <>
            <Upload className="w-5 h-5" />
            Upload Health Documents ({healthDocs.length}/5)
          </>
        )}
      </button>

      {healthDocs.length === 0 && (
        <div className="flex items-center gap-2 p-3 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-lg">
          <AlertCircle className="w-5 h-5 text-[#D4AF37]" />
          <span className="text-sm text-[#D4AF37]">
            At least one health document is required for breeding service listings
          </span>
        </div>
      )}
    </div>
  );
};
